










import {Component, Vue} from 'vue-property-decorator';

@Component({})
export default class Submit extends Vue {
  private get timeoutLong() {
    return this.$store.getters.timeoutLong;
  }
}
